module.exports = __webpack_public_path__ + "img/12.5e7016e3.jpg";